module.exports = function stubUndefined() {
  // eslint-disable-next-line no-void, sonarjs/void-use, require-unicode-regexp
  return void /undefined/
}